export const CM_TIMELINE_VIEW_FLAG_NAME = 'pen-5613_v1'

export const ANCHORS = {
  JOURNEY: 'journey',
  REVIEWS: 'reviews',
  CLASS: 'class',
}
